var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-field"},_vm._l((_vm.images),function(image,index){return _c('ABImage',{key:`${index}-${image.src}`,attrs:{"src":image.src,"alt":image.alt,"lazy":true}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }